module.exports = __webpack_public_path__ + "img/22_74.1e4b2019.png";